import React from "react";

import { view } from "modules/Post";

const CreatePostPage = () => <view.CreateUpdatePost />;

export default CreatePostPage;
